import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import DataTable from "../../Components/Common/datatable/DataTable";
import {
  Autocomplete,
  Box,
  Grid,
  Checkbox,
  Chip,
  TextField,
  Tooltip,
  Skeleton,
  Typography,
  Breadcrumbs,
  Popper,
} from "@mui/material";
import TopSection from "../../Components/Common/Top/TopSection";
import SettingsIcon from "@mui/icons-material/Settings";
import DeleteIcon from "@mui/icons-material/Delete";
import ButtonComponent from "../../Components/Common/button/Button";
import ApiService from "../../utils/fetch";
import { useSelector } from "react-redux";
import { MessagePopup } from "../../Components/Common/messagePopup/MessagePopup";
import { AddAPhotoOutlined } from "@mui/icons-material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Switch from "@mui/material/Switch";
import { styled, alpha } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import { set } from "lodash";
// import DataElementConfigurationDialog from "./DataElementConfigurationDialog";
import DataElementConfiguration from "./DataElementConfiguration";
import BlackWhiteSwitch from "./BlackWhiteSwitch";
import BottlerForecastTab from "./BottlerForecastTab";
import BottlerMarketForecastTab from "./BottlerMarketForecastTab";
import FGInventoryTab from "./FGInventoryTab";
import BottlerBusinessPlanTab from "./BottlerBusinessPlanTab";
import ConcentrateInventoryTab from "./ConcentrateInventoryTab";
import ProductionRequirementTab from "./ProductionRequirementTab";

function UserDetails() {
  const location = useLocation();
  const navigate = useNavigate();
  const gridRef = useRef(null);
  const pcGridRef = useRef(null);

  const data = location.state?.data;

  const [selectedDataElement, setSelectedDataElement] = useState(null);
  const [applicableDataElementOption, setApplicableDataElementOption] =
    useState([]);
  const [isEditing, setIsEditing] = useState(false);

  const [email, setEmail] = useState("");
  const inputRef = useRef(null);

  useEffect(() => {
    fetchUserEmail();
  }, [data]);

  useEffect(() => {
    if (data?.applicableDataElementsList) {
      setApplicableDataElementOption(data.applicableDataElementsList);
    } else {
      setApplicableDataElementOption([]);
    }
  }, [data]);

  const fetchUserEmail = async () => {
    if (!data?.id) return;
    try {
      const response = await ApiService.get(
        `/v1/admin/userManagement/get-email?userId=${data.id}`,
      );
      setEmail(response.data);
    } catch (error) {
      console.error("Error fetching user email:", error);
    }
  };

  const handleSubmit = (selectedValues) => {
    setApplicableDataElementOption(selectedValues || []);
  };

  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const isEmailValid = email && email.trim() !== "";

  return (
    <>
      <TopSection
        labelList={[
          { title: "Home", path: "/dashboard" },
          { title: "History" },
        ]}
        title=""
      />
      <div className="container">
        <Box>
          {/* <Typography variant="subtitle1" align="left" gutterBottom={true}>
            User Details
          </Typography>
          <InfoPopover margin="0 0 3px 0" /> */}
          <Breadcrumbs
            separator={<NavigateNextIcon fontSize="small" />}
            aria-label="breadcrumb"
            sx={{ mb: 2 }}
          >
            <Link
              href="/manage-user"
              onClick={(e) => {
                e.preventDefault();
                navigate("/manage-user");
              }}
              style={{ color: "black", textDecoration: "underline" }}
            >
              Manage Users
            </Link>

            <Typography color="text.primary">User Detail</Typography>
          </Breadcrumbs>
          <Grid container spacing={0.5} marginTop={1}>
            <Grid item xs={12} sm={4}>
              <TextField
                id="userName"
                label="User Name"
                value={`${data.firstName || ""} ${data.lastName || ""}`}
                InputProps={{
                  readOnly: true,
                  style: { fontSize: "13px" },
                }}
                InputLabelProps={{
                  shrink: true,
                  style: {
                    transform: "translate(14px, -14px) scale(0.75)",
                  },
                }}
                variant="outlined"
                fullWidth
                size="small"
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                id="role"
                label="Role"
                value={data.roles || ""}
                InputProps={{
                  readOnly: true,
                  style: { fontSize: "13px" },
                }}
                InputLabelProps={{
                  shrink: true,
                  style: {
                    transform: "translate(14px, -14px) scale(0.75)",
                  },
                }}
                variant="outlined"
                fullWidth
                size="small"
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                id="email"
                label="Email *"
                inputRef={inputRef}
                value={email || ""}
                onChange={(e) => setEmail(e.target.value)}
                InputProps={{
                  readOnly: !isEditing,
                  style: { fontSize: "13px" },
                  endAdornment: (
                    <>
                      {!isEditing ? (
                        <IconButton
                          size="small"
                          onClick={() => {
                            setIsEditing(true);
                            setTimeout(() => {
                              inputRef.current?.focus();
                            }, 100);
                          }}
                          edge="end"
                        >
                          <EditIcon />
                        </IconButton>
                      ) : (
                        <IconButton
                          size="small"
                          onClick={async () => {
                            if (!emailRegex.test(email)) {
                              MessagePopup({
                                icon: "error",
                                title: "Invalid Email",
                                message: "Please enter a valid email address.",
                                confirmButtonText: "Ok",
                                confirmButtonColor: "#000000",
                              });
                              return;
                            }
                            try {
                              await ApiService.post(
                                `/v1/admin/userManagement/update-email`,
                                {
                                  userId: data.id,
                                  emailId: email,
                                },
                              );
                              MessagePopup({
                                icon: "success",
                                title: "Success",
                                message: "E-mail updated successfully.",
                              });
                              setIsEditing(false);
                            } catch (error) {
                              MessagePopup({
                                icon: "error",
                                title: "Error",
                                message:
                                  "Failed to update email. Please try again.",
                              });
                            }
                          }}
                          edge="end"
                        >
                          <SaveIcon />
                        </IconButton>
                      )}
                    </>
                  ),
                }}
                InputLabelProps={{
                  shrink: true,
                  style: {
                    transform: "translate(14px, -14px) scale(0.75)",
                  },
                }}
                variant="outlined"
                fullWidth
                size="small"
              />
            </Grid>
          </Grid>

          <Box sx={{ marginTop: 2 }}>
            <DataElementConfiguration
              selectedData={applicableDataElementOption}
              onSubmit={handleSubmit}
              userId={data.id}
            >
              {applicableDataElementOption.map((element, index) => {
                if (element === "Bottler Concentrate Forecast") {
                  return (
                    <BottlerForecastTab
                      key={index}
                      data={data}
                      email={email}
                      isEmailValid={isEmailValid}
                    />
                  );
                }
                if (element === "Bottler Market Forecast") {
                  return (
                    <BottlerMarketForecastTab
                      key={index}
                      data={data}
                      email={email}
                      isEmailValid={isEmailValid}
                    />
                  );
                }
                if (element === "Bottler Bussiness Plan") {
                  return (
                    <BottlerBusinessPlanTab
                      key={index}
                      data={data}
                      email={email}
                      isEmailValid={isEmailValid}
                    />
                  );
                }
                 if (element === "FG Inventory") {
                  return (
                    <FGInventoryTab
                      key={index}
                      data={data}
                      email={email}
                      isEmailValid={isEmailValid}
                    />
                  );
                }
                if (element === "Concentrate Inventory") {
                  return (
                    <ConcentrateInventoryTab
                      key={index}
                      data={data}
                      email={email}
                      isEmailValid={isEmailValid}
                    />
                  );
                }
                if (element === "Production Requirement") {
                  return (
                    <ProductionRequirementTab
                      key={index}
                      data={data}
                      email={email}
                      isEmailValid={isEmailValid}
                    />
                  );
                }
                return (
                  <Typography key={index}>
                    Configuration for {element} coming soon...
                  </Typography>
                );
              })}
            </DataElementConfiguration>
          </Box>
        </Box>
      </div>
    </>
  );
}

export default UserDetails;
